module.exports = __webpack_public_path__ + "img/ministerio-de-salud.272489eb.png";